module.exports = __webpack_public_path__ + "static/img/Kaiden-Lahrs.d69280b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kaiden-Lahrs.jpg
// module id = ladA
// module chunks = 0